var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h6", { staticClass: "mb-1" }, [
        _vm._v(" " + _vm._s(_vm.$t("Imposto Seletivo")) + " "),
      ]),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "tax-parameter-selective-tax-st",
                  name: "tax-parameter-selective-tax-st",
                  type: "vue-select",
                  options: _vm.comboCstCbsIbs,
                  placeholder: _vm.$t("Selecione"),
                  label: _vm.$t("Situação Trib. Imposto Seletivo"),
                },
                model: {
                  value: _vm.fiscalTaxParameter.stSelectiveTaxCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.fiscalTaxParameter, "stSelectiveTaxCode", $$v)
                  },
                  expression: "fiscalTaxParameter.stSelectiveTaxCode",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "tax-parameter-selective-tax-fiscal-classification",
                  name: "tax-parameter-selective-tax-fiscal-classification",
                  disabled: !_vm.fiscalTaxParameter.stSelectiveTaxCode,
                  type: "vue-select",
                  options: _vm.comboSelectiveClassTribs,
                  placeholder: _vm.$t("Selecione"),
                  label: _vm.$t("Classificação Imposto Seletivo"),
                },
                model: {
                  value:
                    _vm.fiscalTaxParameter.fiscalClassificationSelectiveTaxCode,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.fiscalTaxParameter,
                      "fiscalClassificationSelectiveTaxCode",
                      $$v
                    )
                  },
                  expression:
                    "fiscalTaxParameter.fiscalClassificationSelectiveTaxCode",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "2" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "tax-parameter-selective-tax-type",
                  name: "tax-parameter-selective-tax-type",
                  type: "vue-select",
                  options: _vm.comboSelectiveTaxTypes,
                  label: _vm.$t("Tipo de Imposto Seletivo"),
                },
                model: {
                  value: _vm.fiscalTaxParameter.selectiveTaxType,
                  callback: function ($$v) {
                    _vm.$set(_vm.fiscalTaxParameter, "selectiveTaxType", $$v)
                  },
                  expression: "fiscalTaxParameter.selectiveTaxType",
                },
              }),
            ],
            1
          ),
          _vm.fiscalTaxParameter.selectiveTaxType === "PERCENTAGE_BY_BASE_VALUE"
            ? _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "tax-parameter-selective-tax-percent",
                      name: "tax-parameter-selective-tax-percent",
                      type: "text-percetage",
                      currency: "%",
                      precision: 4,
                      label: _vm.$t("% Imposto Seletivo"),
                      validation: "required|number|min:0.00|max:1",
                      "validation-messages": Object.assign(
                        {},
                        _vm.mxGetTextPercentageValidationMessages
                      ),
                    },
                    model: {
                      value: _vm.fiscalTaxParameter.selectiveTaxPercent,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.fiscalTaxParameter,
                          "selectiveTaxPercent",
                          $$v
                        )
                      },
                      expression: "fiscalTaxParameter.selectiveTaxPercent",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.fiscalTaxParameter.selectiveTaxType === "PERCENTAGE_BY_UNIT"
            ? _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "tax-parameter-selective-tax-value-per-unit",
                      name: "tax-parameter-selective-tax-value-per-unit",
                      type: "text-percetage",
                      currency: "R$",
                      precision: 4,
                      label: _vm.$t("Valor por Unidade Imposto Seletivo"),
                    },
                    model: {
                      value: _vm.fiscalTaxParameter.selectiveTaxValuePerUnit,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.fiscalTaxParameter,
                          "selectiveTaxValuePerUnit",
                          $$v
                        )
                      },
                      expression: "fiscalTaxParameter.selectiveTaxValuePerUnit",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }